import type { DateAsString } from '@generated-types';

// 2025-07-28T13:05:11.231252
// To 25.10.2025
export const formatDateString = (dateString: DateAsString): string => {
    const dateObj = new Date(dateString);

    return dateObj.toLocaleDateString('no-NO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};

// 2025-07-28T13:05:11.231252
// To 25 okt. 2025
export const formatDateStringToVerbose = (dateString: DateAsString): string => {
    const dateObj = new Date(dateString);

    return dateObj.toLocaleDateString('no-NO', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
};
